import { Component, OnInit, AfterContentInit, OnDestroy, ViewChild, EventEmitter, ElementRef, HostBinding } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal, NgbTabset, NgbTabChangeEvent, NgbTab } from '@ng-bootstrap/ng-bootstrap';
import { ModalResultStyleService } from './modal-result-style.service';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ViewStackComponent } from '../../view-stack/view-stack.component';
import { DictHandler } from 'src/app/types/@types/sl-v-types';
import { SLMap } from 'src/app/model/sl-map';
import { ResultStyleEditorComponent } from '../../result-style-editor/result-style-editor.component';




@Component({
	selector: 'app-result-style-entry-component',
	templateUrl: './modal-result-style.component.html',
	styleUrls: ['./modal-result-style.component.scss']
})
export class ModalResultStyleEntryComponent implements OnInit, AfterContentInit {

	private map: SLMap;
	@ViewChild('views', { static: true }) views !: ViewStackComponent;
	@ViewChild('tabs', { static: true }) tabs !: NgbTabset;

	@ViewChild('buttonOne', { static: true }) buttonOne: ElementRef;
	@ViewChild('buttonTwo', { static: true }) buttonTwo: ElementRef;
	@ViewChild('selectedResultStyle', { static: true }) selectedResultStyle: ResultStyleEditorComponent;
	@ViewChild('unselectedResultStyle', { static: true }) unselectedResultStyle: ResultStyleEditorComponent;
	@ViewChild('inputStyle', { static: true }) inputStyle: ResultStyleEditorComponent;
  @HostBinding('class.modal-result-style') dialogStyle = true;
	@HostBinding('class.work-view') workView = true;
	/*@ViewChild(GeocodeComponent) geoCodeView: GeocodeComponent;
	@ViewChild(LngLatFormComponent) latLonView: LngLatFormComponent;
	@ViewChild(UtmFormComponent) utmView: UtmFormComponent;
*/

	public actions: EventEmitter<any> = new EventEmitter();
	private handler: DictHandler;

	public selectedStyle: string;
	public unselectedStyle: string;
	public resultInputStyle: string;

	public selectedLabel= $('<span class="fas fa-swatchbook tab-name"></span> Selected');

	constructor(private activeModal: NgbActiveModal, private domNode: ElementRef) { }
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	public viewName = 'selected';
	ngOnInit() {
	}
	ngAfterContentInit() {
		this.subscriptionMgr.Subscribe(this.tabs.tabChange, (data: NgbTabChangeEvent) => {
			switch (data.nextId) {
				case 'modal-selected-result-style-tab':
					this.ShowView('selected');
					break;
				case 'modal-unselected-result-style-tab':
					this.ShowView('unselected');
					break;
				case 'modal-result-input-style-tab':
					this.ShowView('inputs');
					break;
			}

		});
		// $('nav-link::before','this.domNode.nativeElement').prepend('<span class="fas fa-swatchbook"></span>');
		this.buttonOne.nativeElement.addEventListener('click', () => {
			this.HandleButtonOne();
		});
		this.buttonTwo.nativeElement.addEventListener('click', () => {
			this.activeModal.close();
		});


	}
	ShowView(viewName: string, delayed: boolean = false) {
		this.views.SetView(viewName);
		this.viewName = viewName;
		if (!!this.tabs.tabs) {
			if (delayed === false) {
				if (viewName === this.viewName) {
					return;
				}
			}
			this.tabs.tabs.forEach((item: NgbTab) => {
				const target = item.title.toLowerCase();
				if (target === viewName) {
					this.tabs.select(item.id);
				} else	if(target === 'input features' && viewName==='inputs') {
					this.tabs.select(item.id);
				}
			});
		} else {
			setTimeout(() => {
				this.ShowView(viewName, true);
			}, 50);
		}
	}
	Show(info: any) {
		this.ShowView(info.type);
		if (!!info.handler) {
			this.handler = info.handler;
		}
		if (!!info.map) {
			this.map = info.map;
			this.selectedResultStyle.Show(this.map.styles.selected);
			this.unselectedResultStyle.Show(this.map.styles.unselected);
			this.inputStyle.Show(this.map.styles.resultInput);
		}

	}
	HandleButtonOne() {
		// Get data for each view
		// call handler with action 'data/update-result-styles',data: result style object
		this.map.styles.selected = this.selectedResultStyle.value;
		this.map.styles.unselected = this.unselectedResultStyle.value;
		this.map.styles.resultInput = this.inputStyle.value;
		this.map.UpdateStyledLayers();
		this.NotifyListeners();
		this.activeModal.close();
	}
	HandleSelectedChange(event) {
		this.selectedStyle = event.value;
	}
	HandleUnSelectedChange(event) {
		this.unselectedStyle = event.value;

	}
	HandleInputChange(event) {
		this.resultInputStyle = event.value;

	}


	NotifyListeners() {
		this.handler({ selectedStyle: this.selectedStyle, unselectedStyle: this.unselectedStyle, inputStyle: this.resultInputStyle });
	}

}

@Component({
	selector: 'app-modal-result-style',
	template: ''
})
export class ModalResultStyleComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: ModalResultStyleService) {
		this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
			this.modalRef = this.modalService.open(ModalResultStyleEntryComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as ModalResultStyleEntryComponent).Show(info);
		});
	}
	ngOnDestroy() {
		this.subscriptionMgr.CancelSubscriptions();
	}
}
